import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ParkOutlinedIcon from '@mui/icons-material/ParkOutlined';
import PetsOutlinedIcon from '@mui/icons-material/PetsOutlined';
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined';
import { Login, LoginForm } from 'react-admin';
import logo from './assets/zoonsk-logo.png';

export const LoginPage = () => (
    <Login
        className="zoonsk-login"
        avatarIcon={
            <Box
                component="img"
                src={logo}
                alt="Zoo NSK"
                className="zoonsk-login-logo"
            />
        }
    >
        <Box className="zoonsk-login-art" aria-hidden="true">
            <Box className="zoonsk-login-orbit zoonsk-login-orbit-one" />
            <Box className="zoonsk-login-orbit zoonsk-login-orbit-two" />
            <Box className="zoonsk-login-firefly zoonsk-login-firefly-one" />
            <Box className="zoonsk-login-firefly zoonsk-login-firefly-two" />
            <Box className="zoonsk-login-firefly zoonsk-login-firefly-three" />

            <Box className="zoonsk-login-art-copy">
                <Typography className="zoonsk-login-eyebrow">
                    Панель управления зоопарком
                </Typography>
                <Typography component="p" className="zoonsk-login-art-title">
                    Всё важное —<br />в одном месте
                </Typography>
                <Typography component="p" className="zoonsk-login-art-text">
                    Удобная работа с животными, маршрутами и событиями Zoo NSK.
                </Typography>
            </Box>

            <Box className="zoonsk-login-features">
                <Box className="zoonsk-login-feature zoonsk-login-feature-main">
                    <Box className="zoonsk-login-feature-icon"><PetsOutlinedIcon /></Box>
                    <Box>
                        <Typography component="span">Животные</Typography>
                        <Typography component="small">Карточки и статусы</Typography>
                    </Box>
                </Box>
                <Box className="zoonsk-login-feature zoonsk-login-feature-route">
                    <RouteOutlinedIcon />
                    <Typography component="span">Маршруты</Typography>
                </Box>
                <Box className="zoonsk-login-feature zoonsk-login-feature-park">
                    <ParkOutlinedIcon />
                    <Typography component="span">Территория</Typography>
                </Box>
            </Box>
        </Box>

        <Box className="zoonsk-login-heading">
            <Box className="zoonsk-login-security">
                <LockOutlinedIcon />
                <Typography component="span">Защищённый доступ</Typography>
            </Box>
            <Typography variant="h4" component="h1" className="zoonsk-login-title">
                С возвращением
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Войдите в панель управления Zoo NSK
            </Typography>
        </Box>
        <LoginForm />
    </Login>
);
